<template>
  <div class="the-news" v-loading="loading">
    <el-row type="flex" align="middle">
      <el-col :span="12">
        <h3>Новини</h3>
        <p class="the-news__total">Всього: {{ this.total }}</p>
      </el-col>
      <el-col>
        <el-button
          class="the-news__button-create"
          type="primary"
          size="small"
          @click="$router.push('/news-create')">Добавити новину</el-button>
      </el-col>
    </el-row>

    <el-table class="the-news__list" :data="news" empty-text="Немає новин">
      <el-table-column
        label="Заголовок"
        prop="title"
        width="300">
      </el-table-column>
      <el-table-column
        label="Опублікована"
        width="200">
        <template slot-scope="scope">
          {{ formatDate(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            circle
            @click="handleEdit(scope.row)"></el-button>
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDelete(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="total >= limit"
      background
      layout="prev, pager, next"
      :page-size="limit"
      :total="total"
      @current-change="hadlePageChange">
    </el-pagination>
  </div>
</template>

<script>
/**
 * Component: the-news - Компонент списка новостей
 *
 * @version 1.0.0
 */

import * as dayjs from 'dayjs';
import { apiGetNews, apiDeleteNewsPost } from '@/api';
import { Auth } from 'aws-amplify';
import { mapGetters } from 'vuex';

export default {
  name: 'the-news',

  data() {
    return {
      news: [],
      limit: 10,
      offset: 0,
      total: 0,
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
  },

  created() {
    this.getNews();
  },

  methods: {
    async getToken() {
      const userSession = await Auth.userSession(this.user);
      return userSession.accessToken.jwtToken;
    },

    async getNews() {
      this.loading = true;

      const token = await this.getToken();
      const { data } = await apiGetNews(token, {
        limit: this.limit,
        offset: this.offset,
      });

      this.news = data.news;
      this.total = data.total;
      this.loading = false;
    },

    formatDate(date) {
      return dayjs(date).format('DD.MM.YYYY HH:mm');
    },

    hadlePageChange(page) {
      this.offset = page * this.limit - this.limit;

      this.getNews();
    },

    handleEdit({ _id }) {
      this.$router.push(`/news-create?id=${_id}`);
    },

    async handleDelete(article) {
      const token = await this.getToken();

      this.$confirm('Ви впевнені, що хочете видалити цю новину?', 'Увага!', {
        confirmButtonText: 'Так',
        cancelButtonText: 'Ні',
        type: 'warning',
        center: true,
      }).then(() => new Promise((res, rej) => {
        // eslint-disable-next-line
        apiDeleteNewsPost(token, article._id)
          .then(response => res(response))
          .catch(error => rej(error));
      })).then(() => {
        this.getNews();

        this.$message({
          type: 'success',
          message: 'Видалено.',
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Дію скасовано.',
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-news {
  $this: &;

  &__list {
    margin-bottom: $vp;
  }
  &__total {
    color: #909399;
    font-size: 12px;
  }
  &__button-create {
    float: right;
  }
}
</style>
